export const TOKEN_MIN_LENGTH = 22;
export const TOKEN_MAX_LENGTH = 64;

const TOKEN_CHAR_CLASS = '[A-Za-z0-9_-]';

export const TOKEN_FORMAT_REGEX = new RegExp(
  `^${TOKEN_CHAR_CLASS}{${TOKEN_MIN_LENGTH},${TOKEN_MAX_LENGTH}}$`,
);

export const TRIP_PATH_REGEX = new RegExp(
  `^/t/(${TOKEN_CHAR_CLASS}{${TOKEN_MIN_LENGTH},${TOKEN_MAX_LENGTH}})$`,
);

export const USER_PATH_REGEX = new RegExp(
  `^/u/(${TOKEN_CHAR_CLASS}{${TOKEN_MIN_LENGTH},${TOKEN_MAX_LENGTH}})$`,
);

export function isValidTokenFormat(token: unknown): token is string {
  return typeof token === 'string' && TOKEN_FORMAT_REGEX.test(token);
}
